
import { ISDKInfo } from '@kontent-ai/core-sdk';
export const sdkInfo: ISDKInfo = {
    host: 'npmjs.com',
    version: '16.4.6',
    name: '@kontent-ai/delivery-sdk'
};
